module.exports = "<uch></uch>\r\n<head-title params='title:\"权限管理\"'></head-title>\r\n<entitlement></entitlement>";


//////////////////
// WEBPACK FOOTER
// ./src/component/entitlement/EntitlementIndex.html
// module id = 201
// module chunks = 0